import DailyQuiz from "./DailyQuiz";

const QuizBoardDailyQuiz = () => {
  return (
    <section className="py-md-5 py-3 my-md-5 my-3 QuizBoardDailyQuiz">
      <div className="container px-0">
        <div className="row justify-content-center">
          <div className="col-lg-10 px-md-0 px-4">
            <div className="text-center mb-5 animate-fade-in">
              <div className="d-flex align-items-center justify-content-center mb-3">
                <div className="bg-gradient-primary p-3 rounded-circle shadow-glow me-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-brain text-white"
                  >
                    <path d="M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z"></path>
                    <path d="M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z"></path>
                    <path d="M15 13a4.5 4.5 0 0 1-3-4 4.5 4.5 0 0 1-3 4"></path>
                    <path d="M17.599 6.5a3 3 0 0 0 .399-1.375"></path>
                    <path d="M6.003 5.125A3 3 0 0 0 6.401 6.5"></path>
                    <path d="M3.477 10.896a4 4 0 0 1 .585-.396"></path>
                    <path d="M19.938 10.5a4 4 0 0 1 .585.396"></path>
                    <path d="M6 18a4 4 0 0 1-1.967-.516"></path>
                    <path d="M19.967 17.484A4 4 0 0 1 18 18"></path>
                  </svg>
                </div>
                <h2 className="display-5 fw-bold mb-0">Daily Coding Trivia</h2>
              </div>
              <p className="lead text-muted-custom">
                Test your programming knowledge with today's questions!
              </p>
            </div>
            <DailyQuiz />
          </div>
        </div>
      </div>
    </section>

  )
}

export default QuizBoardDailyQuiz;